// extracted by mini-css-extract-plugin
export default {"page":"LoginPage_page__JPuJT","column":"LoginPage_column__eYy-J","card":"LoginPage_card__-0iez","auth":"LoginPage_auth__fPZpr"};